// dailyLogs.ts — Patch 016.1.X.
//
// Frontend client for Heritage's daily site-log surface. Backend route
// is workers/core-os/src/routes/daily_logs.ts.

import { request } from './request'

export interface DailyLog {
  id: string
  project_id: string
  log_date: string
  weather_summary: string | null
  crews_on_site_json: string | null
  work_performed_summary: string | null
  delays_or_issues: string | null
  created_by_user_id: string | null
  created_at: string
}

export interface CreateDailyLogInput {
  log_date: string // ISO YYYY-MM-DD
  weather_summary?: string
  crews_on_site?: string[]
  work_performed_summary?: string
  delays_or_issues?: string
  owner_hours?: number // owner's hours on the build this day (FCC scaling metric)
}

export interface PatchDailyLogInput {
  log_date?: string
  weather_summary?: string
  crews_on_site?: string[]
  work_performed_summary?: string
  delays_or_issues?: string
}

const pid = (id: string): string => encodeURIComponent(id)

export const dailyLogsApi = {
  list: (projectId: string) =>
    request<{ ok: true; logs: DailyLog[] }>(
      `/api/projects/${pid(projectId)}/daily-logs`,
    ),
  create: (projectId: string, body: CreateDailyLogInput) =>
    request<{ ok: true; id: string; log_date: string; request_id: string }>(
      `/api/projects/${pid(projectId)}/daily-logs`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
  update: (projectId: string, logId: string, body: PatchDailyLogInput) =>
    request<{ ok: true; id: string; updated: string[] }>(
      `/api/projects/${pid(projectId)}/daily-logs/${pid(logId)}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
}
